import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

const cardData = [
  {
    title: 'Superbuy Spreadsheet Ultimate Guide',
    description: 'Comprehensive beginner-friendly guide covering everything you need to know about discovering products efficiently with organized resources.',
    readTime: '10 min read',
    link: '/article/superbuy-spreadsheet-guide',
    icon: 'ri-book-open-line',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-500',
    isExternal: false,
  },
  {
    title: 'Safety Guide: Shop Smart & Protected',
    description: 'Essential safety practices every international buyer should follow when researching and purchasing products online.',
    readTime: '8 min read',
    link: '/article/superbuy-spreadsheet-safety',
    icon: 'ri-shield-check-line',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-500',
    isExternal: false,
  },
  {
    title: '10 Proven Shopping Tips & Strategies',
    description: 'Learn the strategies experienced international shoppers use to find better products and save time.',
    readTime: '9 min read',
    link: '/article/superbuy-spreadsheet-tips',
    icon: 'ri-lightbulb-line',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-500',
    isExternal: false,
  },
  {
    title: 'Superbuy Spreadsheet vs Manual Search',
    description: 'Side-by-side comparison showing how organized resources outperform traditional manual searching methods.',
    readTime: '7 min read',
    link: '/article/superbuy-spreadsheet-comparison',
    icon: 'ri-scales-3-line',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-500',
    isExternal: false,
  },
  {
    title: 'Visit Main Website - Full Catalog',
    description: 'Access the complete shopping experience with all product categories and purchasing options on our main platform.',
    readTime: 'External',
    link: mainSiteUrl,
    icon: 'ri-external-link-line',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-500',
    isExternal: true,
  },
];

export default function ArticleCarousel() {
  return (
    <section className="py-24 md:py-32 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
          <div>
            <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 mb-3">
              Superbuy Spreadsheet <span className="text-primary-500">Resources</span>
            </h2>
            <p className="text-foreground-500 text-base md:text-lg max-w-[550px]">
              Expert guides and tips to help you discover products smarter and make better purchasing decisions
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-foreground-950 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
            <i className="ri-article-line text-xs"></i>
            Updated 2026
          </span>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide">
          {cardData.map((card, i) => (
            <div
              key={i}
              className="flex-shrink-0 w-[300px] md:w-[340px]"
            >
              {card.isExternal ? (
                <a
                  href={card.link}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block h-full p-6 rounded-2xl bg-background-100 hover:bg-background-200/70 transition-colors group cursor-pointer"
                >
                  <div className={`w-10 h-10 rounded-xl ${card.iconBg} flex items-center justify-center mb-5`}>
                    <i className={`${card.icon} ${card.iconColor} text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 mb-3 group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed mb-5">
                    {card.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-foreground-400 text-xs">{card.readTime}</span>
                    <span className="text-foreground-950 text-xl font-heading font-semibold">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                  </div>
                </a>
              ) : (
                <Link
                  to={card.link}
                  className="block h-full p-6 rounded-2xl bg-background-100 hover:bg-background-200/70 transition-colors group cursor-pointer"
                >
                  <div className={`w-10 h-10 rounded-xl ${card.iconBg} flex items-center justify-center mb-5`}>
                    <i className={`${card.icon} ${card.iconColor} text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 mb-3 group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed mb-5">
                    {card.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-foreground-400 text-xs">{card.readTime}</span>
                    <span className="text-foreground-950 text-xl font-heading font-semibold">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                  </div>
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}